import * as Actions from './constants';
/**
* Action for setting initial state
* @param {Object} state initial state of a store
* @return {Object} declared action
*/

export function setInitialState(state) {
  return {
    type: Actions.SET_INITIAL_STATE,
    payload: {
      state: state
    }
  };
}
/**
* Action for setting user phone recover choice
* @return {Object} declared action
*/

export function setPhoneRecover() {
  return {
    type: Actions.USER_CHOOSE_PHONE_RECOVER
  };
}
/**
* Action for setting user email recover choice
* @return {Object} declared action
*/

export function setEmailRecover() {
  return {
    type: Actions.USER_CHOOSE_EMAIL_RECOVER
  };
}
/**
* Action for resetting user recover choice
* @return {Object} declared action
*/

export function resetRecoverType() {
  return {
    type: Actions.USER_RESET_RECOVER
  };
}
/**
* Action for setting recovery code validity check to fetching state
* @param {String} recoveryCode recover code
* @return {Object} declared action
*/

export function checkRecoveryCodeValidityFetch(recoveryCode) {
  return {
    type: Actions.CHECK_RECOVERY_CODE_VALIDITY_FETCH,
    payload: {
      recoveryCode: recoveryCode
    }
  };
}
/**
* Action for setting recovery code validity check to error state
* @param {Number} attemptCount recover attempt count
* @param {String} recoverToken token for recovering
* @return {Object} declared action
*/

export function checkRecoveryCodeValiditySuccess(attemptCount, recoverToken) {
  return {
    type: Actions.CHECK_RECOVERY_CODE_VALIDITY_SUCCESS,
    payload: {
      attemptCount: attemptCount,
      recoverToken: recoverToken
    }
  };
}
/**
* Action for setting recovery code validity check to invalid or expired state
* @return {Object} declared action
*/

export function checkRecoveryCodeValidityInvalidOrExpired() {
  return {
    type: Actions.CHECK_RECOVERY_CODE_VALIDITY_EXPIRED_OR_INVALID
  };
}
/**
* Action for setting recovery code validity check to error state
* @return {Object} declared action
*/

export function checkRecoveryCodeValidityError() {
  return {
    type: Actions.CHECK_RECOVERY_CODE_VALIDITY_ERROR
  };
}
/**
* Action for setting recover password by email to fetching state
* @param {String} email email
* @return {Object} declared action
*/

export function recoverByEmailFetch(email) {
  return {
    type: Actions.RECOVER_BY_EMAIL_FETCH,
    payload: {
      email: email
    }
  };
}
/**
* Action for setting Google captcha token state
* @param {String} captchaToken Google captcha token
* @return {Object} declared action
*/

export function setCaptchaToken(captchaToken) {
  return {
    type: Actions.SET_CAPTCHA_TOKEN,
    payload: captchaToken
  };
}
/**
* Action for setting recover password by email to success state
* @param {Number} attemptCount recover attempt count
* @param {String} recoverToken recover token from last attempt
* @param {String} email recipients email
* @return {Object} declared action
*/

export function recoverByEmailSuccess(attemptCount, recoverToken, email) {
  return {
    type: Actions.RECOVER_BY_EMAIL_SUCCESS,
    payload: {
      attemptCount: attemptCount,
      recoverToken: recoverToken,
      email: email
    }
  };
}
/**
* Action for setting recover password by email to error state
* @return {Object} declared action
*/

export function recoverByEmailError() {
  return {
    type: Actions.RECOVER_BY_EMAIL_ERROR
  };
}
/**
* Action for setting recover password by email to invalid state
* @return {Object} declared action
*/

export function recoverByEmailInvalid() {
  return {
    type: Actions.RECOVER_BY_EMAIL_INVALID
  };
}
/**
* Action for setting recover password by phone to fetching state
* @param {String} phoneNumber phone number
* @return {Object} declared action
*/

export function recoverByPhoneFetch(phoneNumber) {
  return {
    type: Actions.RECOVER_BY_PHONE_FETCH,
    payload: {
      phoneNumber: phoneNumber
    }
  };
}
/**
* Action for setting recover password by phone to success state
* @param {Number} attemptCount recover attempt count
* @param {String} recoverToken recover token from last attempt
* @param {String} phoneNumber recipients phone number
* @return {Object} declared action
*/

export function recoverByPhoneSuccess(attemptCount, recoverToken, phoneNumber) {
  return {
    type: Actions.RECOVER_BY_PHONE_SUCCESS,
    payload: {
      attemptCount: attemptCount,
      recoverToken: recoverToken,
      phoneNumber: phoneNumber
    }
  };
}
/**
* Action for setting recover password by phone to error state
* @return {Object} declared action
*/

export function recoverByPhoneError() {
  return {
    type: Actions.RECOVER_BY_PHONE_ERROR
  };
}
/**
* Action for setting recover password by phone to invalid state
* @return {Object} declared action
*/

export function recoverByPhoneInvalid() {
  return {
    type: Actions.RECOVER_BY_PHONE_INVALID
  };
}
/**
* Action for going to user lockdown due to exceeding invalid recovery attempt limit
* @return {Object} declared action
*/

export function userLockdown() {
  return {
    type: Actions.USER_LOCKDOWN
  };
}
/**
 * Action for saving new password
 * @param {String} newPassword new pasword for save
 * @return {Object} declared action
 */

export function savePasswordFetch(newPassword) {
  return {
    type: Actions.SAVE_PASSWORD_FETCH,
    payload: {
      newPassword: newPassword
    }
  };
}
/**
 * Action for setting new password to success state
 * @return {Object} declared action
 */

export function savePasswordSuccess() {
  return {
    type: Actions.SAVE_PASSWORD_SUCCESS
  };
}
/**
 * Action for setting new password to error state
 * @return {Object} declared action
 */

export function savePasswordError() {
  return {
    type: Actions.SAVE_PASSWORD_ERROR
  };
}